type IngredifindAppConfig = {
  apiBaseUrl: string;
  isPrPreview: boolean;
};

export const config = {
  apiBaseUrl: process.env.API_BASE_URL,
  // Only `vite build --mode pr` sets this, and that build is deployed to
  // per-PR Firebase preview channels, never to live hosting.
  isPrPreview: process.env.MODE === "pr",
} as IngredifindAppConfig;
